import React from 'react'

const FlexColWrap = ({ gap, className, children }) => {
  return <div className={`${className ?? ''} flex flex-col ${gap ? `gap-[${gap}]` : 'gap-3'}`}>{children}</div>
}

export default FlexColWrap
